import { ContentPlaceholder, Loader, TabHeader, TabList } from 'components';
import { isEmpty } from 'lodash/fp';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getCurrentCommunity } from 'store/selectors/currentCommunity';
import { getdefaultEventSettings } from 'store/selectors/defaultEventSetting';

import { TabListContainer } from '../styled';
import { useEventTypes } from './hooks';

const EventTypesPage = () => {
  const { t } = useTranslation();
  const community = useSelector(getCurrentCommunity);
  const eventTypesAndDefaultSeeting = useSelector(getdefaultEventSettings);

  const filteredEventTypeAndDefaultSeetings = eventTypesAndDefaultSeeting
    ?.filter((eventType) => eventType.eventType?.deletedAt === null)
    .sort(
      (a, b) =>
        new Date(a.eventType.createdAt).getTime() -
        new Date(b.eventType.createdAt).getTime(),
    );

  const { onAdd, onEdit, onDelete } = useEventTypes(community.id);

  return filteredEventTypeAndDefaultSeetings ? (
    <>
      <TabHeader
        title={t('communitySettings.tabs.eventTypes')}
        onAdd={onAdd}
        text={t('common.toolTipText.eventType')}
      />
      {!isEmpty(eventTypesAndDefaultSeeting) ? (
        <TabListContainer>
          <TabList
            items={filteredEventTypeAndDefaultSeetings}
            onEdit={onEdit}
            onDelete={onDelete}
            onDefaultSetting={onEdit}
          />
        </TabListContainer>
      ) : (
        <ContentPlaceholder />
      )}
    </>
  ) : (
    <Loader />
  );
};

export default EventTypesPage;
